const procedure = (procedure = null, action) => {
    switch (action.type) {
      case "SET_PROCEDURE":
        return action.procedure;
      default:
        return procedure;
    }
  };
  export default procedure;
  